import { Component, OnInit } from '@angular/core';
import { Apollo, gql } from 'apollo-angular';
const internalQuery  = gql`query dataQuery {
  lead_levels{
    id
    name
  }
}`;

const externalQuery = gql`query dataQuery {
  supply_tags{
    id
    name
  }
}`;

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {

/* --------------------------------- Fields --------------------------------- */

  title = 'dental360App';

/* ------------------------------- Constructor ------------------------------ */

  constructor(private apollo: Apollo){

  }

/* ------------------------------- Ng On Init ------------------------------- */

  ngOnInit(){
    // this.apollo.query({
    //   query: internalQuery
    // }).subscribe(data=>{
    //   console.log(data);
    // })

    this.apollo.use("external").query({
      query: externalQuery
    }).subscribe(data=>{
      console.log(data);
    })
  }
}
